// src/utils/blockedUrls.js
export const authCheckUrls = [
    '/reserve/reserve',
    '/reserve/reservation',
    '/reserve/reservationDoctor',
    '/mypage',
    '/register'
];